import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcAnalysisClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.2441 16.4252C15.5695 16.7506 16.0971 16.7506 16.4226 16.4252C16.748 16.0998 16.748 15.5721 16.4226 15.2467L11.1785 10.0026L16.4226 4.75853C16.748 4.43309 16.748 3.90545 16.4226 3.58002C16.0971 3.25458 15.5695 3.25458 15.2441 3.58002L9.99998 8.82409L4.7559 3.58002C4.43047 3.25458 3.90283 3.25458 3.57739 3.58002C3.25195 3.90545 3.25195 4.43309 3.57739 4.75853L8.82147 10.0026L3.57739 15.2467C3.25195 15.5721 3.25195 16.0998 3.57739 16.4252C3.90283 16.7506 4.43047 16.7506 4.7559 16.4252L9.99998 11.1811L15.2441 16.4252Z",
		fill: "#A9AFBB"
	})
});
export default SvgIcAnalysisClose;
